<template>
  <div class="PaB-order-summary">
    <h3>Order Summary</h3>

    <table>
      <tbody>
        <tr>
          <th><strong>Subtotal</strong> ({{ itemCount }} {{ 'item' | pluralize(itemCount) }})</th>
          <td>
            <pretty-money :amt="subtotal | currency({cents: true})" />
          </td>
        </tr>
        <tr>
          <th><strong>Taxes</strong> <span v-if="!this.taxes"> (included)</span></th>
          <td>
            <pretty-money :amt="taxes | currency({cents: true})" v-if="taxes" />
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <th>Total</th>
          <td>
            <pretty-money :amt="total | currency({cents: true})" />
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.PaB-order-summary {
  table {
    tbody {
      th,
      td {
        font-weight: normal;
      }
      td {
        text-align: right;
      }
    }
    tfoot {
      th,
      td {
        font-size: 18px;
        font-weight: bold;
      }
      td {
        text-align: right;
      }
    }
  }
}
</style>

<script>
export default {
  props: ['items'],
  computed: {
    itemCount () {
      return this.items.reduce((previous, current) => {
        previous += +current.quantity
        return previous
      }, 0)
    },
    subtotal () {
      return this.items.reduce((previous, current) => {
        previous += +current.price * +current.quantity
        return previous
      }, 0)
    },
    taxes () {
      return this.$store.getters['venue/getTaxAmount'](this.subtotal)
    },
    total () {
      this.$emit('onTotalChange', this.subtotal + this.taxes)
      return this.subtotal + this.taxes
    }
  }
}
</script>
